import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { BaseFormComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { TimeReportingFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import CreateDeviationTypeForm from "./createTypeForm";
//#endregion
import * as Yup from "yup";

const CreateDeviationTypeFormContainer: ForwardRefRenderFunction<FormHandles, BaseFormComponentProps> = (
  props,
  ref
) => {
  const initialValues = {
    name: "",
    comment: "",
  } as TimeReportingFormTypes.CreateDeviationType;

  const validationSchema = Yup.object<TimeReportingFormTypes.CreateDeviationType>({
    name: Yup.string().required(TranslationKeys.Validations.Required),
    comment: Yup.string(),
  });

  const handleSubmit = async (values: TimeReportingFormTypes.CreateDeviationType) => {
    return values;
  };

  return (
    <CreateDeviationTypeForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={initialValues}
      handleSubmit={handleSubmit}
    />
  );
};

export default forwardRef(CreateDeviationTypeFormContainer);
